import Provider from './Provider';

class VimeoPlayer extends Provider {
    constructor(videoId, playerBox) {
        super();
        this.videoId = videoId;
        this.playerBox = playerBox;
        this.player = false;
    }

    playerScriptSrc() {
        return 'https://player.vimeo.com/api/player.js';
    }

    playerScriptId() {
        return 'vimeo-player-iframe-api';
    }

    #createPlayer() {
        if (this.playerExist()) {
            return;
        }

        this.player = new window.Vimeo.Player(this.playerBox, {
            id: this.videoId,
            height: '360',
            width: '640',
        });

        this.play();
    }

    // eslint-disable-next-line consistent-return
    createPlayerBox() {
        if (document.getElementById(this.playerScriptId())) {
            this.#createPlayer();
            return;
        }

        this.loadVideoScripts(() => this.#createPlayer());
    }

    play() {
        if (this.playerExist()) {
            this.player.play();
        }
    }

    pause() {
        if (this.playerExist()) {
            this.player.pause();
        }
    }
}

export default VimeoPlayer;